import React from 'react';
import { parseAccent } from '../primitives/SplitText';

// Static text with *accent* words in the italic serif (the lab scrubs whole blocks, not words)
const Accent = ({ text }) =>
  parseAccent(text).map(({ word, accent }, i) => (
    <span key={i} className={accent ? 'accent' : undefined}>
      {word}
    </span>
  ));

export default Accent;
